import Typography from "@anwb/typography";
import { TaskPostponedMessageDetails, TypedStatusUpdateMessage } from "@status-updates/types";
import { DateTime } from "luxon";
import { FrontendState, StateMetadata } from "../frontend-state";

export class DiagnosisPostponedNotCompletedState extends FrontendState<TaskPostponedMessageDetails> {
  constructor(
    message: TypedStatusUpdateMessage<TaskPostponedMessageDetails>,
    metadata: StateMetadata
  ) {
    super(message, metadata, {
      illustration: "auto-op-brug",
      title: "De diagnose is nog niet compleet",
    });
  }

  renderTimelineItems() {
    const { timeFragment } = this.message.messageDetails;
    return [
      {
        timestamp: DateTime.fromISO(this.message.created),
        title: this.options.title,
        content: (
          <Typography data-e2e-test-type="status-updates-diagnosis-not-completed" tagName="div">
            Wij hebben contact gehad met de garage, maar we weten nog niet wat er mis is met{" "}
            {this.getInformalOrFormal("jouw", "uw")} voertuig. Wij gaan opnieuw contact opnemen met
            de garage.
            <br />
            {timeFragment.charAt(0).toUpperCase() + timeFragment.slice(1)} verwachten we{" "}
            {this.getInformalOrFormal("je", "u")} meer te kunnen vertellen.
          </Typography>
        ),
        feedback: this.renderFeedback(),
      },
    ];
  }
}
